import { forwardRef } from 'react';
import { withDirtyFormProxyButton } from './withDirtyFormProxyButton';
import { BaseButtonProps } from '../BaseButton';
import { DirtyFormProxyButtonProps } from './types';
import { RouteLinkDomPropsType } from '../RouteLink/type';

const SimpleLink = forwardRef<HTMLAnchorElement, BaseButtonProps & DirtyFormProxyButtonProps & RouteLinkDomPropsType>(
	({ dataTestId, children, onClick, onMouseDown, ...props }, ref) => (
		<a
			data-testid={dataTestId}
			rel='noreferrer noopener'
			ref={ref}
			// @ts-ignore
			onMouseDown={onMouseDown}
			// @ts-ignore
			onClick={onClick}
			{...props}
		>
			{children}
		</a>
	),
);

const DirtyFormProxyLinkControlled = withDirtyFormProxyButton(SimpleLink);

DirtyFormProxyLinkControlled.displayName = 'DirtyFormProxyLinkControlled';

export default DirtyFormProxyLinkControlled;
export { DirtyFormProxyLinkControlled };
